import axios from "axios";
import utils from "@/services/utils";

export default {
  async search(searchOptions) {
    try {
      const response = await axios.get("/whale/", {
        params: {
          ...utils.buildApiSearchQuery(searchOptions, "whaleId", false),
          species: (searchOptions?.species ?? []).join(";"),
          archived: searchOptions?.archived ?? false,
        },
      });
      const data = response.data;
      return { message: "Got whales", data: data.items, total: data.total };
    } catch (e) {
      return { message: "No whales found", data: [], total: 0 };
    }
  },
  async create(whaleToCreate) {
    return await axios.post(`/whale/`, whaleToCreate);
  },
  async update(whaleId, whaleToUpdate) {
    return await axios.put(`/whale/${whaleId}`, whaleToUpdate);
  },
  async delete(whaleId) {
    return await axios.delete(`/whale/${whaleId}`);
  },
  async archive(whaleId) {
    return await axios.put(`/whale/${whaleId}/archive`);
  },
  async restore(whaleId) {
    return await axios.put(`/whale/${whaleId}/restore`);
  },
  async merge({ survivorId, duplicateId, fieldOverrides }) {
    return await axios.post("/whale/merge", {
      survivorId,
      duplicateId,
      fieldOverrides: fieldOverrides ?? null,
    });
  },
  async getDuplicates(whaleId) {
    try {
      const response = await axios.get(`/whale/duplicates/${encodeURIComponent(whaleId)}`);
      return { data: response.data };
    } catch (e) {
      return { data: [] };
    }
  },
  async sightingsForWhale(whaleId) {
    try {
      const response = await axios.get("/sighting/", {
        params: { whale_id: whaleId, limit: -1 },
      });
      return { data: response.data.items };
    } catch (e) {
      return { data: [] };
    }
  },
  async imagesForWhale(whaleId) {
    try {
      const response = await axios.get("/sighting/images", {
        params: { whale_id: whaleId },
      });
      return { data: response.data.items };
    } catch (e) {
      return { data: [] };
    }
  },
  async unassociatedImages() {
    try {
      const response = await axios.get("/sighting/images", {
        params: { unassociated_only: true, limit: -1 },
      });
      return { data: response.data.items };
    } catch (e) {
      return { data: [] };
    }
  },
  async allImages() {
    try {
      const response = await axios.get("/sighting/images", {
        params: { limit: -1 },
      });
      return { data: response.data.items };
    } catch (e) {
      return { data: [] };
    }
  },
  async setFeaturePhoto(whaleId, imageId) {
    return await axios.put(`/whale/whale_feature_photo/${whaleId}/${imageId}`);
  },
  async getByWhaleId(whaleId) {
    try {
      const response = await axios.get(`/whale/by_whale_id/${whaleId}`);
      return { data: response.data };
    } catch (e) {
      return { data: null };
    }
  },
  async byMatriline(matriline) {
    try {
      const response = await axios.get(`/whale/by_matriline/${encodeURIComponent(matriline)}`);
      return { data: response.data };
    } catch (e) {
      return { data: [] };
    }
  },
  async whaleIds() {
    try {
      const response = await axios.get("/whale/whale_ids");
      return { data: response.data };
    } catch (e) {
      return { data: [] };
    }
  },
  async unregisteredWhaleIds() {
    try {
      const response = await axios.get("/whale/unregistered_whale_ids");
      return { data: response.data };
    } catch (e) {
      return { data: [] };
    }
  }
};
